import { DropDown } from '@knitagency/agency-utils';

export default class StaticFaq {
  constructor(section) {
    this.el = section.el;
    this._initDropDown(section);

    const faqTabs = section.el.querySelectorAll('[data-faq-tab]');

    faqTabs.forEach(tab => {
      const tabId = tab.dataset.handle;

      tab.addEventListener('click', e => {
        e.preventDefault();
        faqTabs.forEach(element => element.classList.remove('font-bold'));
        tab.classList.add('font-bold');
        this._scrollToSection(tabId);
      });
    });
  }

  _initDropDown(section) {
    const el = section.el.querySelector('[data-faq-block]');

    new DropDown({
      el: el,
      triggerClass: 'faq-trigger',
      contentClass: 'faq-content',
      closeOnClickOutside: false,
      closeOthers: false,
    });
  }

  _scrollToSection(tabId) {
    const element = document.getElementById(tabId);
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: element.offsetTop - 100,
    });
  }
}
